import React, { useState } from 'react';
import PackageTab from '../components/PackageTab';
import DeployTab from '../components/DeployTab';
import './PackageAndDeploy.css';

function PackageAndDeploy() {
  const [activeTab, setActiveTab] = useState('package');

  return (
    <div className="main-content">
      <h1>🚀 Package & Deploy</h1>
      <div className="alert-info">
        <strong>📖 Need help?</strong> Check out the full{' '}
        <a href="/documentation" style={{ color: 'inherit', fontWeight: 'bold' }}>
          App Documentation
        </a>{' '}
        for detailed instructions and FAQs.
      </div>
      <hr className="divider" />

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'package' ? 'active' : ''}`}
          onClick={() => setActiveTab('package')}
        >
          Package Dashboard
        </button>
        <button
          className={`tab ${activeTab === 'deploy' ? 'active' : ''}`}
          onClick={() => setActiveTab('deploy')}
        >
          Deploy Dashboard
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'package' ? <PackageTab /> : <DeployTab />}
      </div>
    </div>
  );
}

export default PackageAndDeploy;

